import { ExtendedUser } from '@/types/extended';
import { TripInput } from '@/types/index';
import axios from 'axios';

export default async function useNewTrip(data: TripInput): Promise<ExtendedUser> {
	const res = await axios.post('/api/mutations/trip', data);
	return res.data;
}
